import { CRM_FEATURES } from 'crm-cards-sdk/types/CrmFeatures';
export const RecordsFeatures = [CRM_FEATURES.COMMUNICATOR_EMAIL, CRM_FEATURES.COMMUNICATOR_CALLING];